import { Directive, ElementRef, Input, OnInit } from '@angular/core';
declare const L: any;
@Directive({
  selector: '[appMap]'
})
export class MapDirective implements OnInit {
  @Input('appMap') markers: { lat: number, lng: number, style?: any, popupText?: string }[];
  @Input('style') style: string
  constructor(private el: ElementRef) { }

  ngOnInit() {
    const element: HTMLDivElement = this.el.nativeElement;
    if (!element || !this.el) {
      return;
    }
    // Height has to be set. You can do this in CSS too.
    element.style.height = '400px';
    element.style.borderRadius = '8px';
    element.style.width = '100%';
    element.style.zIndex = '2';

    // Create Leaflet map on map element.
    const map = L.map(element, { trackResize: false });
    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> desteğiyle'
    }).addTo(map);
    // Target's GPS coordinates.
    if (this.markers && this.markers.length) {

      const target = L.latLng(this.markers[0].lat, this.markers[0].lng);

      // Set map's center to target with zoom 14.
      map.setView(target, 12);
      this.markers.forEach(marker => {
        const markerToAdd = L.latLng(marker.lat, marker.lng);
        let addedMarker = null;
        if (marker.style) {
          addedMarker = L.marker(markerToAdd, { icon: new L.Icon(marker.style) }).addTo(map);
        } else {
          addedMarker = L.marker(markerToAdd).addTo(map);
        }
        if (marker.popupText) {
          addedMarker.on('mouseover', function (e) {
            this.bindPopup(marker.popupText);
            this.openPopup();
          })
          addedMarker.on('mouseout', function (e) {
            this.closePopup();
          })
        }
      })
    }

  }
}
